import { render, staticRenderFns } from "./duelExercise.vue?vue&type=template&id=3151891e&scoped=true"
import script from "./duelExercise.vue?vue&type=script&lang=js"
export * from "./duelExercise.vue?vue&type=script&lang=js"
import style0 from "./duelExercise.vue?vue&type=style&index=0&id=3151891e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3151891e",
  null
  
)

export default component.exports